export const omit = (originalObj = {}, keysToOmit) => {
    if (!originalObj)
        return null;
    return Object.fromEntries(
        Object.entries(originalObj)
            .filter(([key]) => !keysToOmit.includes(key))
    );
}
